module.exports = __webpack_public_path__ + "img/tutorial05.176d624f.png";